import React, { useEffect, useState } from "react";
import AdminSidebar from "../../components/AdminSidebar";
import "./admin.css";

export default function ApprovedResidents() {
  const [approved, setApproved] = useState([]);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;

  const loadApproved = async () => {
    try {
      const res = await fetch(`${API}/api/admin/approved`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!res.ok) {
        setError("Failed to load approved residents");
        return;
      }

      const data = await res.json();
      setApproved(data);
    } catch (err) {
      setError("Server error while loading approved residents");
    }
  };

  useEffect(() => {
    loadApproved();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>Approved Residents</h1>

        {error && <p className="admin-error">{error}</p>}

        <div className="admin-table">
          <div className="admin-header">
            <span>Name</span>
            <span>Email</span>
            <span>Unit</span>
            <span>Tower</span>
          </div>

          {approved.map((u) => (
            <div className="admin-row" key={u.id}>
              <span>{u.name}</span>
              <span>{u.email}</span>
              <span>{u.unitNumber}</span>
              <span>{u.tower || "—"}</span>
            </div>
          ))}

          {approved.length === 0 && !error && (
            <p className="admin-empty">No approved residents</p>
          )}
        </div>
      </div>
    </div>
  );
}